import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactNode } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
interface IProps {
	title?: string;
	titleKey?: string;
	titleValues?: { [key: string]: string };
	titleClassName: string;
	open: boolean;
	onClose: () => void;
	children: ReactNode;
	action?: ReactNode;
	className: string;
	showBackIcon?: boolean;
	subClassName: string;
}
export default function ManagementModal({ open, onClose, children, action, className, title, titleKey, titleValues, titleClassName, showBackIcon, subClassName }: IProps) {
	const { t } = useTranslation();

	const handleClose = () => {
		onClose();
	};
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			PaperProps={{
				className: `rounded-2xl px-3 pt-4 pb-8 max-w-[1152px]  ${className}`,
			}}
		>
			<Box className={`flex items-center justify-between ${subClassName}`}>
				<DialogTitle className={`p-0 text-xl font-normal text-text-primary ${titleClassName}`}>
					{showBackIcon && <KeyboardArrowRightIcon />} {title ? title : t(titleKey!, titleValues!)}
				</DialogTitle>
				<IconButton>
					<CloseIcon className="text-text-secondary" onClick={handleClose} />
				</IconButton>
			</Box>
			<DialogContent>{children}</DialogContent>
			{action && <DialogActions>{action}</DialogActions>}
		</Dialog>
	);
}
